import React, { useEffect, useState } from "react";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLeadById } from "../../../../service/Lead/action";

const VerifyUCDDetails = ({
  match,
  history,
  verifiedUCD = [],
  verifyUCD,
  otpGenerate,
  otp = [],
  firmType,
  firmTypesValue = [],
  getLeadById,
  leadById = [],
}) => {
  const [inputList, setInputList] = useState([
    {
      channel_type: "",
      organization_type: "",
      dealer_pan_no: "",
      dealer_gst_no: "",
      registration_mobile_no: "",
      otp: "",
      state: "",
      firm_type: "",
      lead_id: "",
    },
  ]);

  const [isLoading, setIsLoading] = useState(false);

  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [phoneNo, setPhoneNo] = useState("");
  const [otpGenerateOpen, setOtpGenerateOpen] = useState(false);
  const [textForOtpButton, setTextForOtpButton] = useState("Generate OTP");

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await firmType();
      if (match?.params?.lead_id) {
        await getLeadById(match?.params?.lead_id);
      }
      setIsLoading(false);
    })();
  }, []);

  const handleInput = (val, index) => {
    const list = [...inputList];
    list[0][index] = val;
    setInputList(list);
  };

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  useEffect(() => {
    console.log(verifiedUCD);
    if (parseInt(verifiedUCD?.status) === 200) {
      toast.success(verifiedUCD?.message);
      setTimeout(() => {
        window.location.href = `ucd-dealer-details/${verifiedUCD?.data?.id}`;
      }, 1000);
    } else if (
      verifiedUCD?.status !== undefined &&
      verifiedUCD?.status !== 200
    ) {
      toast.error(verifiedUCD?.message);
    }
  }, [verifiedUCD]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let requestParams = inputList[0];
    requestParams["lat"] = islatlng?.lat;
    requestParams["long"] = islatlng?.lng;
    requestParams["lead_id"] = match?.params?.lead_id ?? "";
    if (requestParams["lat"] == null || requestParams["long"] == null) {
      toast.error("Please enable your location");
      return false;
    }

    // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
    // return
    setIsLoading(true);
    await verifyUCD(requestParams);
    setIsLoading(false);
  };

  useEffect(() => {
    if (phoneNo.length > 9 && phoneNo.length < 11) {
      setOtpGenerateOpen(true);
    } else if (phoneNo.length > 10) {
      setOtpGenerateOpen(false);
      toast.warning("Phone no must be 10 digit");
    }
  }, [phoneNo]);

  const handleGenerateOTP = async (e) => {
    e.preventDefault();
    if (!phoneNo) {
      toast.warning("Please enter phone no.");
    }
    setIsLoading(true);
    await otpGenerate(phoneNo);
    setIsLoading(false);
  };

  useEffect(() => {
    if (otp?.data) {
      handleInput(otp.data, "state");
      setTextForOtpButton("Re-generate OTP");
      toast.success("OTP is generated successfully");
    } else if (otp?.message) {
      toast.error(otp?.message);
    }
  }, [otp]);

  useEffect(() => {
    if (leadById?.data && leadById?.data?.meta_data[0]) {
      handleInput(leadById?.data?.meta_data[0]?.channel_type, "channel_type");
      handleInput(leadById?.data?.number, "registration_mobile_no");
      setPhoneNo(leadById?.data?.number);
    }
  }, [leadById]);

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"UCD Verification"} history={history} />
            {/*BODY*/}
            <div>
              <div className="container-fluid">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                      </div>
                      <div className="mb-4 bg-white">
                        {" "}
                        {/*card*/}
                        <div className="hide card-header bg-lightGreen-active">
                          POC Details
                        </div>
                        <div className="card-body">
                          <div className="user">
                            <div className="form-group row">
                              <div
                                className="col-sm-6 float-field"
                              >
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(
                                      e.target.value,
                                      "channel_type",
                                      e
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Channel Type</option>
                                  <option
                                    value="Dealer"
                                    selected={
                                      inputList[0]["channel_type"] === "Dealer"
                                    }
                                  >
                                    Dealer
                                  </option>
                                  <option
                                    value="DSA"
                                    selected={
                                      inputList[0]["channel_type"] === "DSA"
                                    }
                                  >
                                    DSA
                                  </option>
                                </select>
                                <label className="large-label float-lb">
                                  Channel Type{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 float-field"
                              >
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(
                                      e.target.value,
                                      "organization_type",
                                      e
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Organization Type</option>
                                  <option value="Company">Company</option>
                                  <option value="Individual">Individual</option>
                                </select>
                                <label className="large-label float-lb">
                                  Organization Type
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                            </div>
                            <div className="form-group row">
                              <div
                                className="col-sm-6 float-field"
                              >
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(e.target.value, "firm_type", e);
                                  }}
                                  required={
                                    inputList[0]["organization_type"] ===
                                    "Company"
                                  }
                                >
                                  <option value="">Firm Type</option>
                                  {firmTypesValue.map((val) => {
                                    return (
                                      <>
                                        <option value={val?.id}>
                                          {val?.firm_name}
                                        </option>
                                      </>
                                    );
                                  })}
                                </select>
                                <label className="large-label float-lb">
                                  Firm Type
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 float-field">
                              <input
                                type="text"
                                className="form-control form-control-user"
                                placeholder=" "
                                value={inputList[0]?.dealer_gst_no || ""}
                                onChange={(e) => {
                                    const gstValue = e.target.value;
                                    handleInput(gstValue, "dealer_gst_no", e);

                                    if (gstValue.length === 15) {
                                    // Autofill PAN from valid GST
                                    const panFromGST = gstValue.substring(2, 12);
                                    handleInput(panFromGST, "dealer_pan_no", e);
                                    } else if (gstValue.length < 15) {
                                    // Clear PAN if GST is incomplete or cleared
                                    handleInput("", "dealer_pan_no", e);
                                    }
                                }}
                                required={inputList[0]["organization_type"] !== "Individual"}
                                maxLength={15}
                                minLength={15}
                                />

                                <label className="large-label float-lb">
                                  Dealer GST No
                                  {inputList[0]["organization_type"] !==
                                    "Individual" && (
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  )}
                                </label>
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-sm-6 float-field">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(
                                      e.target.value,
                                      "dealer_pan_no",
                                      e
                                    );
                                  }}
                                  value={inputList[0]?.dealer_pan_no || ""}
                                  required
                                  maxlength={10}
                                  minlength={10}
                                />
                                <label className="large-label float-lb">
                                  Dealer Pan No{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 float-field">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    const value = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    ); // Remove non-numeric characters
                                    handleInput(
                                      value,
                                      "registration_mobile_no",
                                      e
                                    );
                                    setPhoneNo(value);
                                    e.target.value = value; // Update the input field with only numeric characters
                                  }}
                                  required
                                  value={phoneNo}
                                  maxlength={10}
                                  minlength={10}
                                />
                                <label className="large-label float-lb">
                                  Dealer Mobile No{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                            </div>
                            <div className="form-group row">
                                {otp?.data && (
                                    <div className="col-sm-6 float-field">
                                    <input
                                        type="number"
                                        className="form-control form-control-user"
                                        placeholder=" "
                                        onChange={(e) => {
                                        handleInput(e.target.value, "otp", e);
                                        }}
                                        required
                                    />
                                    <label className="large-label float-lb">
                                        Enter OTP{" "}
                                        <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                    </div>
                                )}
                            </div>
                              {otpGenerateOpen && (
                                <>
                                  <div className="col-md-3">
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => {
                                        handleGenerateOTP(e);
                                      }}
                                    >
                                      {textForOtpButton}
                                    </button>
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex">
                    <button className="btn btn-primary">
                      Verify Details
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <BottomMenu />
      </div>
    </>
  );
};

export default VerifyUCDDetails;
